// extracted by mini-css-extract-plugin
module.exports = {"container":"ContactDetails-module--container--3fk_R"};